/* ============================================================
   MT — script propio de la tienda (nddirs-vr)
   Vanilla JS. Un init por componente, todos llamados desde
   DOMContentLoaded. Cada init comprueba si su elemento existe.
   ============================================================ */
if (window.__mtScriptsInit) {
  // Varias secciones cargan mt-scripts.js; evita inicializar dos veces.
} else {
window.__mtScriptsInit = true;
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function elementEnViewport(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh * 0.92 && rect.bottom > 0;
  }

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduceMotion) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    // Revela de inmediato lo que ya está en pantalla al cargar (evita que el
    // primer tramo de la página se quede invisible si el navegador tarda en
    // disparar el IntersectionObserver, o en agentes sin compositor real).
    var pendientes = [];
    els.forEach(function (el) {
      if (elementEnViewport(el)) {
        el.classList.add('mt-visible');
      } else {
        pendientes.push(el);
      }
    });
    if (!pendientes.length || !('IntersectionObserver' in window)) {
      pendientes.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    pendientes.forEach(function (el) { io.observe(el); });
    // Red de seguridad: si por lo que sea el observer nunca dispara para
    // algún elemento (pestaña en segundo plano, navegador atípico...), no
    // dejes contenido invisible para siempre.
    setTimeout(function () {
      pendientes.forEach(function (el) { el.classList.add('mt-visible'); });
    }, 4000);
  }

  function initColorSwitcher() {
    var groups = document.querySelectorAll('[data-mt-colores]');
    groups.forEach(function (group) {
      var swatches = group.querySelectorAll('.mt-swatch');
      var images = group.querySelectorAll('.mt-colores-media img');
      var nombre = group.querySelector('[data-mt-color-nombre]');
      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-color');
          swatches.forEach(function (s) { s.setAttribute('aria-pressed', s === btn ? 'true' : 'false'); });
          images.forEach(function (img) {
            img.classList.toggle('mt-color-activa', img.getAttribute('data-color') === target);
          });
          if (nombre) nombre.textContent = btn.getAttribute('data-nombre') || '';
        });
      });
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('.mt-count[data-target]');
    if (!els.length) return;
    var animate = function (el) {
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var decimals = el.getAttribute('data-decimals') ? parseInt(el.getAttribute('data-decimals'), 10) : 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = value.toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      if (reduceMotion) {
        el.textContent = target.toFixed(decimals) + suffix;
      } else {
        requestAnimationFrame(step);
      }
    };
    if (!('IntersectionObserver' in window)) {
      els.forEach(animate);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initProductoGaleria() {
    var wraps = document.querySelectorAll('[data-mt-producto-galeria]');
    wraps.forEach(function (wrap) {
      var main = wrap.querySelector('.mt-producto-galeria-principal img');
      var thumbs = wrap.querySelectorAll('.mt-producto-thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (main && full) main.src = full;
          thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
        });
      });
    });
  }

  function initProductoOpciones() {
    var wraps = document.querySelectorAll('[data-mt-producto-opciones]');
    wraps.forEach(function (wrap) {
      var pills = wrap.querySelectorAll('.mt-producto-pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var group = pill.closest('[data-mt-opcion-grupo]');
          if (!group) return;
          group.querySelectorAll('.mt-producto-pill').forEach(function (p) {
            p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
          });
        });
      });
    });
  }

  function initTilt() {
    var cards = document.querySelectorAll('.mt-tilt');
    if (!cards.length || reduceMotion) return;
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initTodo() {
    initReveal();
    initColorSwitcher();
    initCountUp();
    initProductoGaleria();
    initProductoOpciones();
    initTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    // El documento ya estaba listo cuando se ejecutó este script (puede pasar
    // si se carga tarde o sin defer): inicializa ya, sin esperar un evento
    // que no va a volver a disparar.
    initTodo();
  }
})();
}
